<template>
    <div style="display: inline-block" :class="btClass">
        <el-button :type="type" @click="importDialog = true"  :class="btClass" :disabled="disabled" >{{$t(i18nPage+text)}}</el-button>
        <el-dialog v-dialogDrag :title="$t(i18nPage+'Excel导入自定义格式设置')" width="720px" :close-on-click-modal="false"
                   :visible.sync="importDialog" @close="closeImportDialog">
            <div class="dialog-content dialog-content-medium">
                <el-form label-position="top" ref="importform" :model="importform" >
                    <div class="section">
                        <!--<div class="title">
                            <span class="title-text">基本信息</span>
                        </div>-->
                        <div class="body">
                            <el-row :gutter=8>
                                <el-col :span=11>
                                    <el-form-item :label="$t(i18nPage+'可用格式')" prop="id">
                                        <span slot="label" v-if="showVerifiedTitle">
                                            <span>{{$t(i18nPage+'可用格式')}}</span>
                                            <el-checkbox v-model="importform.notVerifiedTitle" :true-label=1 :false-label=0 >{{$t(i18nPage+'识别列号')}}({{$t(i18nPage+'通过列号定位列')}})</el-checkbox>
                                        </span>
                                        <call-table ref="userTmpCallTable" table-name="bas_import_usertmp" v-model="importform.id"
                                                    :default-extra="typeNo" @change="userTmpChange"></call-table>
                                    </el-form-item>
                                </el-col>
                                <el-col :span=10 class="colbutton" style="padding-top: 27px">
                                    <el-button type="primary" @click="saveTmp" :loading="saveLoading"  class="zm-button2">{{$t(i18nPage+'保存')}}</el-button>&nbsp;
                                    <el-button type="primary" @click="resaveTmp" :loading="resaveLoading" class="zm-button3">{{$t(i18nPage+'另存为')}}</el-button>&nbsp;
                                    <el-button type="danger" @click="delTmp"  :loading="delLoading" class="zm-button2">{{$t(i18nPage+'删除')}}</el-button>
                                </el-col>
                                <el-col :span=3 class="colbutton" style="padding-top: 27px">
                                    <el-row type="flex" justify="end" >
                                        <el-button type="primary" @click="loadTmp" class="zm-button2">{{$t(i18nPage+'加载')}}</el-button>
                                    </el-row>
                                </el-col>
                            </el-row>

                        </div>
                    </div>
                    <div class="section">
                        <!--<div class="title">
                            <span class="title-text">字段信息</span>
                        </div>-->
                        <div class="body">
                            <el-table :data="importform.fieldList" style="width: 100%" border height="385"  stripe>
                                <el-table-column type="index" :label="$t(i18nPage+'序号')" width="60" align="center"></el-table-column>
                                <el-table-column property="isRequired" :label="$t(i18nPage+'必填')" :formatter="fmtrequired" width="60" align="center" header-align="left"></el-table-column>
                                <el-table-column property="fieldNo" :label="$t(i18nPage+'字段编码')"></el-table-column>
                                <el-table-column property="fieldName" :label="$t(i18nPage+'字段名')"></el-table-column>
                                <el-table-column property="colIndex" :label="$t(i18nPage+'列号')" width="200">
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.colIndex" placeholder="" filterable clearable >
                                            <el-option v-for="item in importform.titleList" :key="item.colIndex"
                                                       :label="item.title" :value="item.colIndex"></el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="secondary-label">
                        <el-row :gutter=8>
                            <el-col :span=24 style="padding-top: 15px">
                                <el-row type="flex" justify="end" >
                                    <zm-file-upload
                                            url="bas/importTmp/title/list"
                                            :sys-type="sysType"
                                            :show-file-list=false
                                            :file-list="fileList"
                                            accept=".xlsx,.xls"
                                            :on-success="handleSuccess"
                                            bt-class="zm-button5"
                                            :bt-text="$t(i18nPage+'导入Excel标题')">
                                    </zm-file-upload>
                                    <!--<el-button type="danger" @click="delTmp"  :loading="delLoading" class="zm-butto6">导入Excel标题</el-button>-->
                                </el-row>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "ZmImpBtn",
        props: {
            sysType:{
                type:String
            },
            type:{
                type:String,
                default:'primary'
            },
            btClass:{
                type:String,
                // default:'zm-button5'
            },
            text:{
                type:String,
                default:'自定义格式'
            },
            method:{
                type:String,
                default:'post'
            },
            getParams:{
                type:Function
            },
            beforeClick:{
                type:Function
            },
            disabled:{
                type:Boolean,
                default:false
            },
            isAsynch:{
                type:Number,
                default:0
            },
            typeNo:{
                type:String,
                required:true
            },
            getUserTmpFieleUrl:{
                type:String,
                default:'bas/importTmpField/tmp/list'
            },
            saveUserTmpUrl:{
                type:String,
                default:'bas/importTmp/user/modify'
            },
            resaveUserTmpUrl:{
                type:String,
                default:'bas/importTmp/user/add'
            },
            delUserTmpUrl:{
                type:String,
                default:'bas/importTmp/user/del'
            },
            dropdownMenuWidth:{
                type:Number,
                default:140
            },
            showVerifiedTitle:{
                type:Boolean,
                default:true
            }
        },
        beforeCreate() {
            this.i18nPage = 'component.ZmImpBtn.';
        },
        data(){
            return {
                i18nPage : 'component.ZmImpBtn.',
                saveLoading:false,
                resaveLoading:false,
                delLoading:false,
                importDialog:false,
                userTmpLoading:false,
                tmpLoading:false,
                colLoading:false,
                importform:{
                    typeNo:'',
                    id:null,
                    templateName:'',
                    notVerifiedTitle:0,
                    fieldList:[],
                    titleList:[]
                },
                fileList:[],
                markFieldList:[],
                allFieldList:[],
                requiredFieldNos:[],
                requiredList:[{label:'否',value:0},{label:'是',value:1}],
                importUsertmpId:null,
                exportTmpId:null,
                col:[
                    {value: 'fieldName',text: this.i18nPage+'列名称',width: 150}
                ],
                userTmpObj:null,
                tmpObj:null,
                tempList:[],
                copyTableList:[],
                reloadMainTable:false
            }
        },
        computed:{

        },
        methods: {
            closeImportDialog(){
                this.$emit('close', '');
            },
            handleSuccess(response, file, fileList) {
                this.importform.titleList =  response.body;
                let titleObj = {};
                if(this.importform.titleList && this.importform.titleList.length > 0){
                    this.importform.titleList.forEach((item, index) => {
                        titleObj[item.sourceTitle] = item.colIndex;
                    })
                }
                this.importform.fieldList.forEach((item,index) => {
                    if(titleObj[item.fieldName]){
                        item.colIndex = titleObj[item.fieldName];
                    }else{
                        item.colIndex = '';
                    }
                    item.title = '';
                });
                this.$util.show(this.$t(this.i18nPage+"标题导入成功"))
            },
            fmtrequired(row, column) {
                const required = row[column.property];
                if (required === 1) {
                    return '√';
                } else {
                    return '';
                }
            },

            buttonRowDelete(index) {
                this.$confirm(this.$t(this.i18nPage+'确定删除此行吗'), this.$t(this.i18nPage+'提示'), {
                    confirmButtonText: this.$t(this.i18nPage+'确定'),
                    cancelButtonText: this.$t(this.i18nPage+'取消'),
                    type: 'warning'
                }).then(() => {
                    this.importform.fieldList.splice(index, 1);
                });
            },
            saveTmp(){
                if(!this.importform.id){
                    this.$util.show(this.$t(this.i18nPage+'请选择格式'),1);
                    return;
                }
                if(!this.importform.fieldList || this.importform.fieldList.length == 0){
                    this.$util.show(this.$t(this.i18nPage+'请设置导入列'),1);
                    return;
                }
               /* if(!this.importform.templateName){
                    this.$util.show('请设置模版名称',1);
                    return;
                }*/
                if(this.importform.titleList == null || this.importform.titleList.length == 0){
                    this.$util.show(this.$t(this.i18nPage+'表头信息有误'),1);
                    return;
                }

                for(var i=0;i<this.importform.fieldList.length;i++){
                    if(this.importform.fieldList[i].isRequired == 1 && !this.importform.fieldList[i].colIndex){
                        this.$util.show(this.importform.fieldList[i].fieldName+this.$t(this.i18nPage+'必填'),1);
                        return;
                    }
                }

                let that = this;
                this.$util.confirm(this.$t(this.i18nPage+'是否对模版字段进行修改'),this.$t(this.i18nPage+'提示')).then(() =>{
                    that.saveLoading = true;
                    that.$httpService.post(that.saveUserTmpUrl,this.importform,{contentType:2}).then(res => {
                        that.saveLoading = false;
                        that.$util.show(this.$t(this.i18nPage+'模版保存成功'));
                    }).catch(() => {
                        that.saveLoading = false;
                    });
                }).catch(() => {
                    this.$util.show(this.$t(this.i18nPage+'取消修改'),1);
                })
            },
            resaveTmp(){
                if(!this.importform.fieldList || this.importform.fieldList.length == 0){
                    this.$util.show(this.$t(this.i18nPage+'请设置导入列'),1);
                    return;
                }
              /*  if(!this.importform.templateName){
                    this.$util.show('请设置模版名称',1);
                    return;
                }*/
                if(this.importform.titleList == null || this.importform.titleList.length == 0){
                    this.$util.show(this.$t(this.i18nPage+'表头信息有误'),1);
                    return;
                }
                for(var i=0;i<this.importform.fieldList.length;i++){
                    if(this.importform.fieldList[i].isRequired == 1 && !this.importform.fieldList[i].colIndex){
                        this.$util.show(this.importform.fieldList[i].fieldName+this.$t(this.i18nPage+'必填'),1);
                        return;
                    }
                }
                /*this.importform.fieldList.forEach((item,index) => {
                    if(item.isRequired == 1 && !item.colIndex){
                        this.$util.show(item.fieldName+'必填',1);
                        return;
                    }
                });*/

                let that = this;
                this.$prompt(this.$t(this.i18nPage+'请输入格式名称'), this.$t(this.i18nPage+'提示'), {
                    confirmButtonText: this.$t(this.i18nPage+'确定'),
                    cancelButtonText: this.$t(this.i18nPage+'取消')
                }).then(({ value }) => {
                    that.importform.templateName = value;
                    that.resaveLoading = true;
                    that.$httpService.post(that.resaveUserTmpUrl,that.importform,{contentType:2}).then(res => {
                        that.resaveLoading = false;
                        that.cleanAndReloadCalltable(res);
                        that.$util.show(this.$t(this.i18nPage+'模版另存为成功'));
                    }).catch(() => {
                        that.resaveLoading = false;
                        // that.$util.show('模版另存为失败');
                    });
                }).catch(() => {
                    this.$util.show(this.$t(this.i18nPage+'取消另存为'));
                });
            },
            delTmp(){
                if(!this.importform.id){
                    this.$util.show(this.$t(this.i18nPage+'请选择导入格式'),1);
                    return;
                }
                let that = this;
                this.$util.confirm(this.$t(this.i18nPage+'是否删除此模版'),this.$t(this.i18nPage+'提示')).then(() =>{
                    that.delLoading = true;
                    that.$httpService.post(that.delUserTmpUrl,{
                        id:this.importform.id
                    }).then(res => {
                        that.delLoading = false;
                        that.importform.id = null;
                        // that.$refs.mainTable.setTableData(this.copyTableList.slice(0));
                        // that.$refs.detailTable.setTableData([]);
                        that.userTmpChange();
                        that.cleanAndReloadCalltable();
                        that.$util.show(this.$t(this.i18nPage+'模版删除成功'));
                    }).catch(() => {
                        that.delLoading = false;
                        // that.$util.show('模版删除失败');
                    });
                }).catch(() => {
                    // this.$util.show('取消删除',1);
                })
            },

            //用户模版选择回调
            userTmpChange(row){
                // this.importform.fieldList = [];
                this.importform.fieldList.forEach((item,index) => {
                    item.title = '';
                });
                this.importform.titleList = [];
                this.importform.fieldList.forEach((item,index) => {
                    item.colIndex = '';
                    item.title = '';
                });
                if(row && row.id){
                    this.importform.templateName = row.templateName;
                    this.importform.notVerifiedTitle = row.notVerifiedTitle;
                    this.$httpService.post(this.getUserTmpFieleUrl,{id:row.id}).then(res => {
                        if(res && res.length > 0){
                            res.forEach((tf,tfindex) => {
                                this.importform.titleList.push({
                                    colIndex:tf.colIndex,
                                    title:tf.title,
                                    sourceTitle:tf.sourceTitle
                                })
                            });
                            res.forEach((tf,tfindex) => {
                                this.importform.fieldList.forEach((field,index2) => {
                                    if(tf.fieldNo == field.fieldNo){
                                        field.colIndex = tf.colIndex;
                                    }
                                })
                            })
                        }
                    });
                }
            },
            cleanAndReloadCalltable(res){
                this.$util.remove('tf:bas_import_usertmp:'+this.typeNo)
                this.$refs['userTmpCallTable'].getTableList(this.typeNo);
                if(res){
                    this.importform.id = res;
                }
            },
            loadTmp(){
                this.importDialog = false;
                this.$emit('loadtmp', this.importform.id);
            }
        },
        created(){
            this.importform.titleList = [];
            this.importform.fieldList = [];
            this.importform.typeNo = this.typeNo;
            this.$httpService.get('bas/importField/transfer/list',{str:this.typeNo}).then(res => {
                if(res && res.length > 0){
                    this.importform.fieldList = res;
                    res.forEach((item,index) => {
                        this.importform.titleList.push({
                            colIndex:item.colIndex,
                            title:item.title,
                            sourceTitle:item.sourceTitle
                        })
                    })
                }else{
                    this.$util.show(this.$t(this.i18nPage+"未获取到对应的类型字段信息"),1);
                }
            });
        }

    };
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// ../../src/components/ZmImpBtn/index.vue